module.exports = __webpack_public_path__ + "static/logoDark-9d29ef5bb609013ddcf4e243948d3ffa.svg";